<template>
  <v-card-actions :class="['form-action-bar', { cardAction: isActive, 'form-action-bar--fixed': fixed }]">
    <slot></slot>
    <v-spacer></v-spacer>
    <v-btn
      v-if="!hideCancel"
      text
      class="text-capitalize"
      :data-cy="`${this.name}CancelBtn`"
      @click.stop.prevent="cancel"
      >Cancel</v-btn
    >
    <v-btn
      :loading="this.loading"
      :disabled="this.disabled"
      v-if="update"
      :data-cy="`${this.name}UpdateBtn`"
      color="primary"
      class="form-action-primary"
      @click.stop.prevent="submit"
      >Update</v-btn
    >
    <v-btn
      :loading="this.loading"
      :disabled="this.disabled"
      v-else 
      color="primary"
      :data-cy="`${this.name}SaveBtn`"
      class="form-action-primary"
      @click.stop.prevent="submit"
      >{{`${this.label}`}}</v-btn
    >
  </v-card-actions>
</template>

<script>
export default {
  props: {
    isActive: {
      default: true,
    },
    hideCancel: {
      default: false,
    },
    update: {
      default: false,
    },
    name: {
      default: 'data-cy',
    },
    loading: {
      default: false,
    },
    disabled: {
      default: false,
    },
    label: {
      default: 'save',
    },
    fixed: {
      default: false,
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    submit() {
      this.$emit('submit');
    },
  },
};
</script>

<style scoped>
.form-action-bar {
  background: var(--v-surface-base) !important;
  border-top: 1px solid var(--v-border-base) !important;
  min-height: 70px;
  width: 100%;
}

.form-action-bar--fixed {
  bottom: 70px;
  box-shadow: 0 -12px 30px rgba(4, 15, 30, 0.18);
  padding: 10px max(16px, calc((100vw - 980px) / 2 + 20px));
  position: fixed;
  z-index: 5;
}

.form-action-bar .v-btn {
  min-height: 44px;
  padding-left: 22px;
  padding-right: 22px;
}

.form-action-primary {
  border-radius: 12px !important;
  color: #fff !important;
  font-weight: 750;
  letter-spacing: 0.02em;
}

@media (max-width: 600px) {
  .form-action-bar--fixed {
    padding: 10px 14px;
  }
}
</style>
